import { Fragment, useState, useEffect, useRef } from 'react'
import './login.css'
import { useFormik } from 'formik'
import { useIsMobile } from '../../../../utils/hooks/useIsMobile'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import * as AuthService from '../../../../services/auth'
import ReCAPTCHA from 'react-google-recaptcha'

const initialValues = {
  password: '',
  password_confirmation: '',
  g_recaptcha_response: '',
}

export function CreateNewPassword() {
  const recaptchaRef = useRef<ReCAPTCHA | null>(null)
  const [loading, setLoading] = useState(false)
  const isMobile = useIsMobile()
  const [inputPassword, setInputPassword] = useState({
    inputType: 'password',
    icon: 'far fa-eye icon',
  })

  const { code } = useParams()
  const navigate = useNavigate()

  const formik = useFormik({
    initialValues,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      setLoading(true)
      try {
        await AuthService.confirmForgotPassword(code, values)
        setLoading(false)
        navigate('/auth/company')
        toast('Berhasil ganti password, silahkan login')
      } catch (error) {
        console.error(error)
        setStatus('The login details are incorrect')
        setSubmitting(false)
        setLoading(false)
      }
    },
  })

  const handleChangeEyeIcon = (icon: string) => {
    if (icon == 'far fa-eye icon') {
      setInputPassword({
        inputType: 'text',
        icon: 'far fa-eye icon fa-eye-slash',
      })
      return
    }

    setInputPassword({
      inputType: 'password',
      icon: 'far fa-eye icon',
    })
  }

  return (
    <Fragment>
      <div
        className='side-one bg-image'
        style={{
          backgroundImage: `url(${require('../../../../assets/img/bg-company.png')})`,
        }}
      >
        <div className='image-small'>
          <img src={require('../../../../assets/img/bg-company.png')} />
        </div>
      </div>
      <div className='side-two'>
        <div className='form-container'>
          <img
            src={require('../../../../assets/img/login-logo.png')}
            alt=''
            className='login-logo'
          />
          <p className='fontsize-42 fontweight-600 mt-5 mb-8'>Reset Password</p>

          <form className='input-container' onSubmit={formik.handleSubmit}>
            <label className='input-label'>Password Baru</label>
            <div className='input-icons'>
              <i
                className={inputPassword.icon}
                style={{ cursor: 'pointer' }}
                onClick={() => handleChangeEyeIcon(inputPassword.icon)}
              />
              <input
                type={inputPassword.inputType}
                {...formik.getFieldProps('password')}
                className='input-form'
              />
            </div>

            <label className='input-label'>Konfirmasi Password Baru</label>
            <div className='input-icons'>
              <i
                className={inputPassword.icon}
                style={{ cursor: 'pointer' }}
                onClick={() => handleChangeEyeIcon(inputPassword.icon)}
              />
              <input
                type={inputPassword.inputType}
                {...formik.getFieldProps('password_confirmation')}
                className='input-form'
              />
            </div>

            <div className='mb-10'>
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey='6Lf3qh8qAAAAAAmCYQOBXog8koATjbM4w7HZBGo2'
                onChange={(value) => formik.setFieldValue('g_recaptcha_response', value)}
                onExpired={() => {
                  formik.setFieldValue('g_recaptcha_response', '')
                  toast.error('Captcha expired, silakan centang ulang.')
                }}
              />

              {formik.touched.g_recaptcha_response && formik.errors.g_recaptcha_response && (
                <div className='text-danger small mt-1'>{formik.errors.g_recaptcha_response}</div>
              )}
            </div>

            <div className='space-between mb-30'>
              <p>
                <Link to={'/auth'} className='color-orange fontweight-600'>
                  Login?
                </Link>
              </p>
            </div>

            <button className='button mb-5' disabled={formik.isSubmitting || !formik.isValid}>
              {loading ? 'Loading ...' : 'Reset Sekarang'}
            </button>

            <p className='text-center fontsize-14 mb-18'>
              <span className='color-grey'>Belum Punya Akun?</span>{' '}
              <Link to={'/company-register'} className='color-dark-blue'>
                Buat Akun di sini
              </Link>
            </p>

            <p className='text-center fontsize-14 color-grey' style={{ maxWidth: '500px' }}>
              Tidak ada bagian dari situs web ini atau isinya yang boleh direproduksi, disalin,
              dimodifikasi atau diadaptasi, tanpa persetujuan tertulis sebelumnya dari LPDP.
            </p>
          </form>
        </div>
      </div>
    </Fragment>
  )
}
